module.exports = __webpack_public_path__ + "static/laser_md-ca7b085066be53e34218f9b5228b70cf.png";